import { render, staticRenderFns } from "./ztjj-xwdt.vue?vue&type=template&id=2ed7de1f&"
import script from "./ztjj-xwdt.vue?vue&type=script&lang=js&"
export * from "./ztjj-xwdt.vue?vue&type=script&lang=js&"
import style0 from "./ztjj-xwdt.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports